module.exports = __webpack_public_path__ + "images/emoji/zap.18e501ed69200684b13a.png";